/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import styled from "styled-components";
import { Text, theme, Tooltip } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";

const StyledText = styled(Text)`
  zoom: 0.9;
`;

dayjs.extend(relativeTime);

type CommentMetadataProps = {
  author: string;
  time: string;
  modified: {
    time: string;
    author: string;
  };
};

function CommentMetadata({ author, time, modified }: CommentMetadataProps) {
  return (
    <FlexContainer direction="column" align="flex-end">
      <StyledText mb="0">{author && author.split("@")[0]}</StyledText>
      <FlexContainer>
        <Text size="sm" mb="0" color={theme.color.text.text02}>
          {dayjs(time).toNow(true)} ago
        </Text>
        {time !== modified.time && (
          <Tooltip
            status="notification"
            caption={
              <>
                <Text size="sm" mb="0">
                  edited by: {modified.author.split("@")[0]}
                </Text>
                <Text size="sm" mb="0" color={theme.color.text.text01}>
                  {dayjs(time).toNow(true)} ago
                </Text>
              </>
            }
          >
            <Text size="sm" mb="0" ml="0.2rem" color={theme.color.text.text02}>
              (edited)
            </Text>
          </Tooltip>
        )}
      </FlexContainer>
    </FlexContainer>
  );
}

export { CommentMetadata };
